/*
 *
 * MsDynamicsVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_MS_DYNAMICS } from './constants';

export const initialState = {
  isVerify: false,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const msDynamicsVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_MS_DYNAMICS.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_MS_DYNAMICS.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_MS_DYNAMICS.ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default msDynamicsVerifyReducer;
